<template>
  <div id="personal">
    <!-- 個人繳費項目內容 -->
    <div
      id="div_personal"
      class="tab-pane fade show"
      role="tabpanel"
    >
      <div class="col-12 pt-3 table-style">
        <!-- 組件-標題 -->
        <v-title>
          <v-font
            font-css="title-age"
            font-text="步驟一：選擇繳款項目"
          />
          <div class="spanfs mt-2">
            <v-font
              slot="etext"
              font-text="Step One: Choose Fee Order"
            />
          </div>
        </v-title>
        <!-- 第一層 篩選 -->
        <div class="form-group row">
          <!-- 篩選資料 -->
          <v-label
            class="lh-fs ml-3"
            for="input-query"
            Labbold="true"
            LabText="篩選資料："
          >
            <v-font
              slot="small"
              font-css="spanfs"
              font-text="Keyword for Search"
            />
          </v-label>
          <div class="col-md-5">
            <input
              id="input-query"
              class="input-style"
              type="text"
              placeholder="請輸入關鍵字"
              v-model="filter"
            >
          </div>
        </div>
        <!-- 第二層 筆數 -->
        <div class="form-group row">
          <v-label
            for="Page-select"
            class="lh-fs ml-3 mr-4"
            style="padding-right: 0.3rem !important;"
            Labbold="true"
            LabText="筆數："
          >
            <v-font
              slot="small"
              font-css="spanfs"
              font-text="Items per Page"
            />
          </v-label>
          <div class="col-md-3">
            <v-page @RecPerPage="RecPerPage" />
          </div>
        </div>
        <hr>
        <v-font
          font-css="small-color"
          font-text="*加入購物車前，請確認有相同繳費通路"
        />
        <!-- 表格資料 -->
        <template>
          <b-table
            hover
            small
            bordered
            show-empty
            stacked="md"
            empty-text="目前無資料"
            empty-filtered-text="查無資料"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <!-- 繳款項目編號 -->
            <template v-slot:cell(FeeOrderId)="data">
              {{ Size(data.item.FeeOrderId) }}
            </template>
            <!-- 金額 -->
            <template v-slot:cell(PayAmt)="data">
              {{ data.item.PayAmt + ' 元' }}
            </template>
            <!-- 功能 -->
            <template v-slot:cell(Actions)="data">
              <!-- 加入鈕,已加入鈕 -->
              <v-button
                v-if="data.item.ShoppingStatus === 0"
                class="lh-fs"
                title="加入"
                btn-text="加入"
                btn-type="primary"
                @click.native="PostAddCart(data.item)"
              >
                <br slot="eg">
                <v-font
                  slot="icon"
                  font-css="spanfss"
                  font-text="Add"
                />
              </v-button>
              <v-button
                v-else
                class="lh-fs"
                title="已加入"
                btn-text="已加入"
                btn-type="secondary"
              >
                <br slot="eg">
                <v-font
                  slot="icon"
                  font-css="spanfss"
                  font-text="Added"
                />
              </v-button>
            </template>
          </b-table>
          <!-- 分頁 -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0 mb-2"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFeeorderQuerypersonal, apiFeeorderShopadd } from '../../../Api/api'
import { fillcompile } from '../../../Api/compile'
export default {
  data () {
    return {
      items: [],
      fields: [
        { key: 'SerialNo', label: '#', thClass: 'table-th' },
        { key: 'FeeOrderId', label: '繳款項目編號\nFee Order Id', thClass: 'table-th' },
        { key: 'PayOrderId', label: '繳費單號\nPay Id', thClass: 'table-th' },
        { key: 'ApplyDeptName', label: '單位\nDepartment', thClass: 'table-th' },
        { key: 'FeeItemName', label: '收費項目名稱\nFee Item Name', thClass: 'table-th', class: 'word-bold', variant: 'warning' },
        { key: 'FeeOrderDesc', label: '事由\nDescription', thClass: 'table-th' },
        { key: 'PayAmt', label: '金額\nAmount', thClass: 'table-th', class: 'short', variant: 'warning', sortable: true },
        { key: 'PayCategory', label: '繳費通路\nPayment Method', thClass: 'table-th', class: 'table-during' },
        { key: 'PayDateEnd', label: '繳費截止日\nPayment Deadline', thClass: 'table-th', class: 'table-nine', sortable: true },
        { key: 'Actions', label: '功能\nAction', thClass: 'table-th' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      FeeItem: {
        FeeItemId: '',
        FeeItemType: '',
        FeeItemCount: '',
        FeeItemValue: '',
        FeeOrderId: ''
      }
    }
  },
  computed: {
    sortOptions () {
      return this.fields1
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted () {
    this.PostQueryPersonal()
  },
  methods: {
    RecPerPage (SublayerPage) {
      this.perPage = SublayerPage
    },
    Size (data) { // 手機版字數超過12換行
      const datas = data.replace(/(.{12})/g, '$1\n')
      return datas
    },
    onFiltered (filteredItems) { // 表格資料頁碼
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    PostQueryPersonal () { // 查詢個人 F_API 007
      // 定義資料
      const vm = this
      const NewData = JSON.parse(localStorage.getItem('M_Identity'))
      vm.$bus.$emit('Cart', 'true') // 發送購物車數量訊息
      // 呼叫API
      apiFeeorderQuerypersonal(NewData).then(
        res => {
          if (res !== undefined) {
            for (let i = 0; i < res.Data.length; i++) { // 遍歷GET data
              const json = res.Data[i] // 添增Count屬性
              json.FeeItemCount = '0'
              json.SerialNo = i + 1
              json.PayCategory = fillcompile(json.PayCategory)
            }
            vm.items = res.Data
            vm.totalRows = vm.items.length
          }
        }
      )
    },
    PostAddCart (data) { // 加入購物車 F_API 009
      // 定義資料
      const vm = this
      vm.FeeItem.FeeItemId = data.FeeItemId
      vm.FeeItem.FeeItemType = data.FeeItemType
      vm.FeeItem.FeeItemCount = data.FeeItemCount
      vm.FeeItem.FeeItemValue = data.FeeItemValue
      vm.FeeItem.FeeOrderId = data.FeeOrderId
      const NewData = Object.assign(JSON.parse(localStorage.getItem('M_Identity')), vm.FeeItem)
      // 呼叫API
      apiFeeorderShopadd(NewData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('Cart', 'true')
            vm.$bus.$emit('messsage:push', '已加入購物車', 'primary')
            vm.PostQueryPersonal()
          }
        }
      )
    }
  }
}
</script>
